import React from 'react'

// Material-UI
//   npm install --save material-ui
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import CircularProgress from 'material-ui/CircularProgress'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'

import ModeSelect from './pages/modeSelect'
import LogIn from './pages/logIn'
import EntryInput from './pages/entryInput'
import InputConfirm from './pages/inputConfirm'
import Authentication from './pages/authentication'
import ConnectTenant from './pages/connectTenant'
import EntryComplete from './pages/entryComplete'

import { MessageDialog, GeneralDialog } from './Dialogs'
import getMyMuiTheme, { darkColor } from './getMyMuiTheme'
import * as def from './define'
import * as WebAPI from './webapi'
import { LOCAL_VERSION } from './local_version'
import { IS_DEBUG } from './is_debug'

import './App.css'

export default class App extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      step: def.STEPS.MODE_SELECT,
      message: '',
      messageVisible: false,

      open: false,
    }
    this.info = this.getInitialInfo()

    this.stepChange = this.stepChange.bind(this)
    this.doLogout = this.doLogout.bind(this)
    this.logout = this.logout.bind(this)
    this.closeMessage = this.closeMessage.bind(this)
    this.messageAreaCallback = this.messageAreaCallback.bind(this)
  }

  componentWillMount() {
    this.retryFunc = null
    this.retryFuncParam = null
    this.forceLogout = false
    this.toTop = false
  }

  componentDidUpdate() {
    if (this.toTop) {
      this.toTop = false
      window.scrollTo(0, 0)
    }
  }

  getInitialInfo() {
    return {
      serviceType: def.SERVICE_TYPE.STAMP,
      mode: def.MODE.CREATE_TENANT,

      token: '',
      serialNo: '',
      phoneNo: '',

      contractId: '',
      companyId: '',
      companyName: '',
      companyPW1: '',
      companyPW2: '',
      pwEffectiveDays: 0,
      needPicture: false,
      needLocation: false,
      adminId: '',
      adminName: '',
      adminPW1: '',
      adminPW2: '',
      adminMailAddress: '',
      mailValidationCode: '',
      isMailAddressValidated: false,
    }

    /*
    this.info = {
      token: 'temporary',
      serialNo: '12345678901234',
      phoneNo: '03-1234-5678',

      contractId: 'abc123',
      companyId: 'kaisha',
      companyName: '○○株式会社',
      companyPW1: '11111111',
      companyPW2: '11111111',
      pwEffectiveDays: 0,
      needPicture: false,
      needLocation: false,
      adminId: 'admin',
      adminName: '応研 太郎',
      adminPW1: '22222222',
      adminPW2: '22222222',
      adminMailAddress: 'a@b.c',
      mailValidationCode: '',
      isMailAddressValidated: false,
    }
    */
  }

  stepChange(info, toStep) {
    this.info = Object.assign({}, info)
    this.toTop = true
    this.setState({ step: toStep })
  }

  doLogout() {
    this.info = this.getInitialInfo()
    this.toTop = true
    this.setState({ step: def.STEPS.MODE_SELECT, message: null, messageVisible: false })
  }

  logout() {
    this.setState({
      message: <GeneralDialog title='初回登録の中止' message={'ここまで入力した内容は保存されません。\n初回登録を中止しますか?'} okButtonLabel='中止する' handleCancelDialog={this.closeMessage} handleCloseDialog={this.doLogout} isDialogOpen={Boolean(true)} />,
      messageVisible: true
    })
  }

  closeMessage() {
    this.setState({ message: null, messageVisible: false })
    if (this.forceLogout) {
      this.forceLogout = false
      this.doLogout()
    }
  }

  messageAreaCallback(msgType, params) {
    switch (msgType) {
      case 'WAIT': // プログレスサークル
        this.setState({ message: <CircularProgress size={80} thickness={7} color={darkColor} />, messageVisible: true })
        break
      case 'APIERR': // エラーメッセージボックス
        this.forceLogout = params.forceLogout || false
        let msg = params.msgBody || ''
        this.setState({
          message: <MessageDialog title='エラー' isOkdisabled={Boolean(false)} handleCloseDialog={this.closeMessage} isDialogOpen={Boolean(true)} message={'サーバーとの通信でエラーが発生しました。\n少し時間をおいて再度お試しください。' + msg} />,
          messageVisible: true
        })
        break
      case 'MSGBOX': // OKボタンのみのメッセージボックス
        let title = params.msgTitle || ''
        let body = params.msgBody || ''
        this.forceLogout = params.forceLogout || false
        this.setState({
          message: <MessageDialog title={title} isOkdisabled={Boolean(false)} handleCloseDialog={this.closeMessage} isDialogOpen={Boolean(true)} message={body} />,
          messageVisible: true
        })
        break
      case 'RELOGIN': // 再ログイン
        this.retryFunc = params.retryFunc
        this.retryFuncParam = params.retryFuncParam
        this.startReLogin()
        break
      default:
        this.setState({ message: null, messageVisible: false })
        break
    }
  }

  onDialogClose() {
    // スーパーリロード実行
    window.location.reload(true)
  }

  render() {
    // UIバージョンチェック
    // サーバーから取得した最新のUIバージョンと、自分が保持しているバージョンを比較
    const localStorage = window.localStorage
    // 自分が保持しているUIに埋め込まれているバージョン（ローカルバージョン）
    const localVer = LOCAL_VERSION
    // ローカルストレージに保持されているバージョン（ストレージバージョン）
    let storageVer = localStorage.getItem(def.LOCAL_STRAGE_KRY.UI_VERSION)
    if (storageVer === null) {
      // ローカスストレージにまだバージョンを保持していない場合は、ローカルバージョンを利用
      storageVer = localVer
    }

    // サーバーから最新のバージョン（サーバーバージョン）を取得
    WebAPI.getUIVersion().then(
      function (res) {
        const serverVer = res.version

        if (localVer !== serverVer && storageVer !== serverVer) {
          // ローカルバージョンとストレージバージョンの両方がサーバーバージョンと違ったら、
          // スーパーリロードで最新のUIを取得する

          // ストレージバージョンをサーバーバージョンに更新することで、リロード完了までは再リロードされるのを防ぐ
          localStorage.setItem(def.LOCAL_STRAGE_KRY.UI_VERSION, serverVer)

          // 確認Dlgを開く（このダイアログが閉じられる時にスーパーリロードが実行される）
          this.setState({ open: true })
        }
      }.bind(this)
    )

    const callbacks = {
      stepChange: this.stepChange,
      logout: this.logout,
      showMessage: this.messageAreaCallback
    }
    let appContent = null
    if (this.info.token.length < 1) {
      if (this.state.step === def.STEPS.LOGIN) {
        appContent = <LogIn info={this.info} callbacks={callbacks} />
      } else {
        appContent = <ModeSelect info={this.info} callbacks={callbacks} />
      }
    } else {
      switch (this.state.step) {
        case def.STEPS.ENTRY_INPUT:
          appContent = <EntryInput info={this.info} callbacks={callbacks} />
          break
        case def.STEPS.INPUT_CONFIRM:
          appContent = <InputConfirm info={this.info} callbacks={callbacks} />
          break
        case def.STEPS.AUTHENTICATION:
          appContent = <Authentication info={this.info} callbacks={callbacks} />
          break
        case def.STEPS.CONNECT_TENANT:
          appContent = <ConnectTenant info={this.info} callbacks={callbacks} />
          break
        case def.STEPS.ENTRY_COMPLETE:
          appContent = <EntryComplete info={this.info} callbacks={callbacks} />
          break
        default:
          break
      }
    }

    return (
      <MuiThemeProvider muiTheme={getMyMuiTheme()}>
        <div className='App'>
          { /* モーダルダイアログやプログレスサークルを表示するためのペイン */}
          <div style={{ position: 'absolute', display: this.state.messageVisible ? 'inline' : 'none', left: '0', top: '0', width: '100%', height: '100%', backgroundColor: '#888888', opacity: '0.4', zIndex: '950' }} />
          <div id='messageArea' style={{ position: 'absolute', display: this.state.messageVisible ? 'inline' : 'none', left: '0', top: '300px', right: '0', bottom: '0', margin: 'auto', opacity: '1', zIndex: '960' }}>
            {this.state.message}
          </div>
          <header>
            <h1 className='tooltip'>スマート大臣 初回登録<span>バージョン {LOCAL_VERSION}</span></h1>
          </header>
          {appContent}
          <footer>
            {'(C) 2017 応研株式会社'}
          </footer>

          <Dialog
            title={'最新のUIに更新します'}
            actions={[
              <FlatButton
                label={'閉じる'}
                onClick={e => this.onDialogClose()} />
            ]}
            modal={Boolean(true)}
            open={this.state.open}
            onRequestClose={e => this.onDialogClose()}>
            <div>
              {'ブラウザのキャッシュ機能により、更新後も古いUIが表示される場合があります。'}
              <br />
              {'古いUIが表示される場合は、ブラウザの再読み込みを行ってください。'}
            </div>
          </Dialog>
        </div>
      </MuiThemeProvider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App.js